import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import StatePositionConstant from "./StatePositionConstant";
import Pagination from "./Pagination";

export default function PositionsList() {
  const [positions, setPositions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [tagHtmlPositionSearchFilter, setTagHtmlPositionSearchFilter] =
    useState();

  useEffect(() => {
    getPosition();
  }, [currentPage, tagHtmlPositionSearchFilter]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPosition = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let position;
    try {
      position = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/position/list?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return position.data.data;
  };

  const getPosition = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultRequestGetPosition = await sendRequestGetPosition(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultRequestGetPosition) {
      return;
    }

    setPositions(resultRequestGetPosition.positions);
    setCountPage(resultRequestGetPosition.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (tagHtmlPositionSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&tag_html_id=${tagHtmlPositionSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.PENDING
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.CONFIRM
      ]:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generatePositions = () => {
    return (
      <>
        <div className="text-left">
          <Link to="/publisher/all" className="btn btn-primary">
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در تگ html جایگاه</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) =>
                    setTagHtmlPositionSearchFilter(e.target.value)
                  }
                  className="form-control"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره جایگاه</td>
                <td>تعداد بنر در جایگاه</td>
                <td>مبلغ پایه</td>
                <td>مبلغ</td>
                <td>Hicoin بنر جایگزین</td>
                <td>اندازه (ارتفاع - عرض)</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تگ html جایگاه </td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {positions.map((position, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(position.id)}</td>
                    <td>{helpersNumbers.toPersianNum(position.count)}</td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.base_price
                        )
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(position.price)
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.score_alternative
                        )
                      )}
                    </td>
                    <td style={{ letterSpacing: "2px" }}>
                      {helpersNumbers.toPersianNum(position.size)}
                    </td>
                    <td>
                      <div dir="ltr" className="text-center">
                        {position.active ? (
                          <span className="badge badge-success">فعال</span>
                        ) : (
                          <span className="badge badge-danger">غیرفعال</span>
                        )}
                      </div>
                    </td>
                    <td dir="ltr">
                      <span
                        className={` badge badge-${getBadgeTypeClassStatePosition(
                          position.state
                        )} `}
                      >
                        {position.state}
                      </span>
                    </td>
                    <td dir="ltr">{position.tag_html_id}</td>
                    <td>
                      {position.tag_html_id && (
                        <span className="pl-2">
                          <button
                            className="btn btn-info"
                            onClick={(e) => {
                              e.preventDefault();
                              navigator.clipboard.writeText(
                                `<div class="hil-banner-advertise" id="${position.tag_html_id}"></div>`
                              );
                              alert("تگ html کپی شد.");
                            }}
                          >
                            <i className="fas fa-copy"></i>
                          </button>
                        </span>
                      )}
                      <span className="pl-2">
                        <Link
                          target="_blank"
                          to={() => {
                            return position.page_id == 0
                              ? `/positions/independent/${position.id}/view`
                              : `/positions/${position.id}/view`;
                          }}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <>
        <div className="text-left">
          <Link to="/publisher/all" className="btn btn-primary">
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img src="/assets/img/do-not-have-position.svg" />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p> شما در حال حاضر هیچ جایگاه ای ندارید :(</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="لیست جایگاه های تبلیغاتی " />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {positions.length === 0 && tagHtmlPositionSearchFilter == null
                ? generatePageDoseNotHaveAnyPositions()
                : generatePositions()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
